import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EnrollmentReportStudent } from 'src/app/component/child-reports/enrollment-report/model/enrollment-report-result.model';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { County } from 'src/app/model/county';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { School, Grade } from 'src/app/model/school.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Student } from 'src/app/model/student/student.model';
import { AgePipe } from 'src/app/pipes/age.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { PagingService } from 'src/app/service/paging.service';
import { QuestionHelpTextService } from 'src/app/service/question-help-text.service';
import { StudentHelperService } from '../../service/student-helper.service';
import { StudentHelper2Service } from '../../service/student-helper2.service';
import { Subscription } from 'rxjs';
import { StudentDeduplicationService } from '../../service/student-deduplication.service';

@Component({
    selector: 'children-deduplication-merge',
    templateUrl: './children-deduplication-merge.component.html',
    styleUrl: './children-deduplication-merge.component.scss'
})
export class ChildrenDeduplicationMergeComponent implements OnInit {
    @ViewChild('compare') compareElement: ElementRef;

    // Search variables
    student1: Student;
    student2: Student;

    studentId1: number;
    studentId2: number;
    studentName1: string;
    regions1: string;
    terminated1: string;
    studentName2: string;
    regions2: string;
    terminated2: string;

    shoppingCart: any[] = [];

    // Help Text
    questionIds: number[] = [];

    lstQuestionHelpText: QuestionHelpText[] = [];

    isLoading: boolean = false;
    isAdding: boolean = false;
    allowLoading: boolean = false;
    showMsg: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();
    getAgePipe = new AgePipe();

    // Permissions
    featuresCheck: string[] = ['Merge Students'];
    featurePermissions: any;

    subs: Subscription[] = [];

    constructor(
        public questionHelpTextService: QuestionHelpTextService,
        public studentDeduplicationService: StudentDeduplicationService,
        public pagingService: PagingService,
        public accessService: AccessService,
        private studentHelperService: StudentHelperService,
        private studentHelper2Service: StudentHelper2Service
    ) {
        this.subscriptions();
    }

    ngOnInit(): void {
        this.isLoading = true;

        // Permissions
        this.getFeaturePermissions();

        this.isLoading = false;
    }

    subscriptions() {
        let studentNameSub = this.studentHelperService.studentName$.subscribe((studentName) => {
            this.studentName1 = studentName;
        });
        let studentNameSub2 = this.studentHelper2Service.studentName$.subscribe((studentName) => {
            this.studentName2 = studentName;
        });

        this.subs.push(studentNameSub);
        this.subs.push(studentNameSub2);

        let regionsSub = this.studentHelperService.regions$.subscribe((regions) => {
            this.regions1 = regions;
        });

        let regionsSub2 = this.studentHelper2Service.regions$.subscribe((regions) => {
            this.regions2 = regions;
        });

        this.subs.push(regionsSub);
        this.subs.push(regionsSub2);

        let terminatedSub = this.studentHelperService.terminated$.subscribe((terminated) => {
            this.terminated1 = terminated;
        });

        let terminatedSub2 = this.studentHelper2Service.terminated$.subscribe((terminated) => {
            this.terminated2 = terminated;
        });

        this.subs.push(terminatedSub);
        this.subs.push(terminatedSub2);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    getFeaturePermissions() {
        this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res: any) => {
            this.featurePermissions = res;
        });
    }

    searchChildrenShoppingCartEvent(shoppingCart: any[]) {
        this.showMsg = false;
        if (shoppingCart && shoppingCart.length > 1) {
            this.shoppingCart = shoppingCart;
        } else {
            this.shoppingCart = [];
            this.chooseStudent1(undefined);
            this.chooseStudent2(undefined);
        }
    }

    chooseStudent1(student: any) {
        this.allowLoading = false;
        this.showMsg = false;

        setTimeout(() => {
            this.student1 = student ? student.value : undefined;
            this.studentId1 = this.student1.ID!;
            this.studentHelperService.setStudentId(this.studentId1);

            if (this.student1 && this.student2) {
                this.allowLoading = true;

                setTimeout(() => {
                    const targetElement = this.compareElement.nativeElement;
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        });
    }

    chooseStudent2(student: any) {
        this.allowLoading = false;
        this.showMsg = false;

        setTimeout(() => {
            this.student2 = student ? student.value : undefined;
            this.studentId2 = this.student2.ID!;
            this.studentHelper2Service.setStudentId(this.studentId2);

            if (this.student1 && this.student2) {
                this.allowLoading = true;

                setTimeout(() => {
                    const targetElement = this.compareElement.nativeElement;
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        });
    }

    addDuplicateResolution() {
        if (this.student1 && this.studentId1 && this.student2 && this.studentId2) {
            this.isAdding = true;

            this.studentDeduplicationService.addDuplicateResolution(this.studentId1, this.studentId2).subscribe((res) => {
                if (res.msg) {
                    if (res.msg.SUCCESS) {
                        this.msg = res.msg;

                        this.chooseStudent1(undefined);
                        this.chooseStudent2(undefined);
                    } else {
                        this.msg = res.msg;
                    }
                    this.showMsg = true;
                    this.isAdding = false;
                } else {
                    this.msg = new MsgModel();
                    this.msg.SUCCESS = false;
                    this.msg.MSG = 'Failed to add these two students to be merged. Server error.';
                    this.showMsg = true;
                    this.isAdding = false;
                }
            });
        }
    }

    trackItem(index: number, item: any) {
        return item.ID;
    }
}
